module.exports = __webpack_public_path__ + "static/media/OutliersQ4_3.b0755998.svg";